export async function GetIntellipayWidget(apiInstance) {
  try {
    const response = await apiInstance.get(`/Payment/intellipay-widget`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}
export async function PostPayment(apiInstance, postData) {
  try {
    const response = await apiInstance.post(`/payment/saverecord`, postData, {
      meta: {
        delayMs: 1000,
        retry: true,
        maxRetries: 1,
        allowRetryOnPost: true,
        timeoutMs: 60000,
      },
    });

    return response;
  } catch (err) {
    throw new Error(`PostPayment failed: ${err.message}`);
  }
}

export async function getCombineBundleOffer(apiInstance, eventId) {
  try {
    const response = await apiInstance.get(
      `/payment/combine-bundle/${eventId}`,
    );
    // 204 No Content means no active bundle includes this combine.
    return { success: true, data: response.data || null };
  } catch (err) {
    return { success: false };
  }
}

// Not retried: the route isn't idempotent, so a retry after a dropped response
// could record the bundle purchase twice for one IntelliPay transaction.
export async function purchaseCombineBundle(apiInstance, postData) {
  try {
    const response = await apiInstance.post(
      `/payment/combine-bundle`,
      postData,
    );

    return response;
  } catch (err) {
    throw new Error(`purchaseCombineBundle failed: ${err.message}`);
  }
}

export async function GetCashToken(apiInstance) {
  try {
    const response = await apiInstance.get(`/Payment/cash-token`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}

export async function CheckValidCashToken(apiInstance, tokenGuid) {
  try {
    const response = await apiInstance.get(`/Payment/is-valid-cash-token`, {
      params: { tokenGuid },
    });
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}
export async function PostIntellipayStoreSuccess(apiInstance, intellipayToken) {
  try {
    const response = await apiInstance.post(`/Payment/store-success`, null, {
      params: { intellipayToken },
    });

    return { success: true, data: response.data };
  } catch (err) {
    console.error("Error response:", err.response?.data || err);
    return { success: false, error: err.response?.data };
  }
}

export async function UpdateIntellipayCardInfo(apiInstance, putData) {
  try {
    const response = await apiInstance.put(`/Payment/cust-update`, putData);
    return response;
  } catch (err) {
    return { success: false };
  }
}

export async function CreateSubscriptionDetails(apiInstance, objSubscription) {
  try {
    const response = await apiInstance.post(
      `/Payment/cust-update`,
      objSubscription,
    );
    return response;
  } catch (err) {
    return { success: false };
  }
}

export async function GetSubscriptionDetails(apiInstance) {
  try {
    const response = await apiInstance.get(`/Payment/subscription-details`);
    return response;
  } catch (err) {
    return { success: false };
  }
}

export const deleteUserSubscription = async (apiInstance) => {
  try {
    const response = await apiInstance.delete(`/Payment/subscription`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
